import TermList from "../AdminTermList";

export default class AdminTermListNotificationStatus extends TermList {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "notification_status";
  }
}
